const FeedUpdateStore = {
  data: {
    updates: [
      {
        title: `New Wiki Page`,
        img: `https://images.unsplash.com/photo-1497671954146-59a89ff626ff?ixlib=rb-0.3.5&s=cc4c9943b6f91be506c77351b14db2c9&auto=format&fit=crop&w=1350&q=80`,
        user: `Joey Brown`,
        avatar: `https://media.licdn.com/dms/image/C5603AQEOhD5eordiyw/profile-displayphoto-shrink_200_200/0?e=1544659200&v=beta&t=5PFwaPEw8El4mfuSqIThQTrmg_kcO0gOMT9sRlGsPc8`,
        date: `Oct. 14, 2018`,
        body: `I have added a new page that can be found on the sidebar. The new page is the Wiki Page information I have started to move from the GitHub Wiki. I have started to make this migration over to here so that I can either set that GitHub page to private or delete it since it is publicly visible. The new page will be updated when time allows and formatted once all of the content has been migrated over to here.`
      },
      {
        title: `Let's get this poppin'!`,
        img: `https://images.unsplash.com/photo-1533713692156-f70938dc0d54?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=6ffb5d270a0b86b0c6e4bbda2f011285&auto=format&fit=crop&w=1267&q=80`,
        user: `Joey Brown`,
        avatar: `https://media.licdn.com/dms/image/C5603AQEOhD5eordiyw/profile-displayphoto-shrink_200_200/0?e=1544659200&v=beta&t=5PFwaPEw8El4mfuSqIThQTrmg_kcO0gOMT9sRlGsPc8`,
        date: `Oct. 10, 2018`,
        body: `Consider this news card the signal for the official launch of our team app! Thank you guys for all of your hard work so far. Let's keep kickin' azz, boiz. It's late, I am exhausted. Here's a vintage emoji:   B-)`
      }
    ]
  },

  addUpdate( update ) {
    FeedUpdateStore.data.updates.push( update );
  }
};

export default FeedUpdateStore;


// WEBPACK FOOTER //
// ./src/stores/FeedUpdateStore.js